import React, { Component } from "react";
import Slider from "react-slick";

const SlickSlider = (props) => {
  return (
      <Slider {...props.settings}>
        {
        (props.images && props.images.length) && props.images.map((image, i) => <div key={`slide-image-${i}`}><div className="bg-image" style={{ backgroundImage: `url(${image})` }}></div></div>)
        }
      </Slider>
  );
}

export default SlickSlider;